"use client";

import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Service } from "@/app/shared/type";
import { API_BASE_URL } from "@/app/api/variable";
import axios from "axios";
import { useState, useEffect } from "react";
import { getSafeImageSrc, createImageErrorHandler } from "@/components/layout/imageUtils";


interface ServicesProps {
  services: Service[];
}
const CDN_BASE_URL = "https://assets.nimbusnode.dev"; // Replace with your CDN URL

export default function Services({ services }: ServicesProps) {
  // State to store signed URLs mapped by service ID

  return (
    <div suppressHydrationWarning>
      <h2 className="global-heading text-[#fff] text-center mb-[10px]">
        What we offer
      </h2>

      <div className="services-container">
        {services.map((service) => {
          const imageUrl = service.icon
            ? `${CDN_BASE_URL}/${service.icon}`
            : "/assets/images/service-icon1.png";
          return (
            <div key={service.slug} className="card">
              <div className="upper-half">
                  <Image
                    src={imageUrl}
                    alt={service.name || "Service Icon"}
                    width={35}
                    height={35}
                    onError={(e) => {
                      e.currentTarget.src = "/assets/images/service-icon1.png";
                    }}
                  />
                <h3>{service.name}</h3>
              </div>
              <div className="lower-half">
                <p>{service.description}</p>
                <div className="learn">
                  <Link href={`/services/#${service.slug}`}>
                    Learn More
                  </Link>
                  <Image
                    src="/assets/images/right-arrow.svg"
                    alt="Arrow Icon"
                    width={18}
                    height={18}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center">
        <Link href={"/services"} className="global-btn">
          View All <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </div>
  );
}
